<template>
  <div class="editor">
        <Editor v-model="myValue" :init="init" :disabled="disabled"/>
        <div class="editor_tip">
            <slot name="tip"></slot>
        </div>
    </div>
</template>

<script>
import OSS from 'ali-oss'
import { nanoid } from "nanoid"
import Editor from "@tinymce/tinymce-vue"
import "tinymce"
import "tinymce/icons/default"
import "tinymce/themes/silver"
import "tinymce/plugins/paste"
import "tinymce/plugins/image"
import "tinymce/plugins/link"
import "tinymce/plugins/code"
import "tinymce/plugins/table"
import "tinymce/plugins/lists"
import "tinymce/plugins/fullscreen"
import "tinymce/plugins/wordcount"

export default {
    name: "MyTinymce",
    components: {
        Editor
    },
    props: {
        value:{
            type:String,
            default:''
        },
        ossOptions:{
            type:Object,
            default:()=>{},
        },
        disabled: Boolean
    },
    data(){
        return {
            myValue: this.value,
            init: {
                language_url: '/static/tinymce/langs/zh_CN.js', //如果语言包不存在，指定一个语言包路径
                language: 'zh_CN', //语言
                skin_url: '/static/tinymce/skins/ui/oxide', //如果主题不存在，指定一个主题路径
                content_css: '/static/tinymce/skins/ui/oxide/content.css',
                height: '500px',
                width: '100%',
                menubar: true, //菜单栏
                browser_spellcheck: false, //拼写检查
                branding: false, //去水印
                elementpath: true, //禁用编辑器底部的状态栏
                statusbar: true, //隐藏编辑器底部的状态栏
                paste_data_images: true, //允许粘贴图像
                themes: 'silver', //主题
                // zIndex: 1101,
                plugins: ['paste', 'code', 'table', 'image', 'lists', 'fullscreen'],
                toolbar: 'fullscreen | undo redo | forecolor backcolor | bold italic underline | formatselect | alignleft aligncenter alignright | bullist numlist | outdent indent | image table | removeformat code',
                fontsize_formats: "10px 12px 14px 16px 18px 24px 36px",
                images_upload_handler: (blobInfo, success, failure) => {
                    this.handleImgUpload(blobInfo, success, failure)
                }
            },
        }
    },
    mounted() {
    },
    watch:{
        value(newValue) {
            this.myValue = newValue;
        },
        myValue(newValue) {
            this.$emit('input', newValue);
        }
    },
    methods: {
        // 用于上传图片的，后端需要提供好上传接口
        handleImgUpload (blobInfo, success, failure) {
            var fileData = blobInfo.blob();
            if(!fileData) return;
            const options = this.ossOptions;
            const client = new OSS({
                // yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
                region: options.Region,
                // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                accessKeyId: options.AccessKeyId,
                accessKeySecret: options.AccessKeySecret,
                // 从STS服务获取的安全令牌（SecurityToken）。
                stsToken: options.SecurityToken,
                // 填写Bucket名称。
                bucket: options.Bucket
            });
            const headers = {
                'Cache-Control': 'public',
                'Content-Disposition':encodeURIComponent(fileData.name),
            }
            let nameID = options.ObjectNamePrefix + nanoid();
            client.put(nameID, fileData, {headers}).then(function (r1) {
                success(r1.url);
            }).catch(function () {
                failure('图片上传失败');
            });

        }
    }
}
</script>
<style scoped>
    .editor{
        max-width: 1200px;
    }
    .editor::v-deep .tox-tinymce--disabled .tox-editor-header{
        display: none;
    }
</style>